import { ContextApi } from 'contexts/Localization/types'
import { Text, Link } from 'vvs-uikit'

export interface VvsGotchiOnboardStep {
  banner: string
  content: (t: ContextApi['t']) => React.ReactNode
}

const onboardSteps: VvsGotchiOnboardStep[] = [
  {
    banner: '/images/vvsGotchi/onboard-banners/step-1-welcome.png',
    content: (t) => (
      <>
        <Text fontSize="20px" fontWeight="600" mb="8px" color="black">
          {t('Welcome to VVSGotchi')}
        </Text>
        <Text fontWeight="600" my="8px" color="black">
          {t(
            'VVSGotchi is an extension of the VVS Miner Moles NFT project, where you can interact with and take your Miner Moles on quests! Read on for a quick overview on how to play, or check out our tutorials ',
          )}
          <Link
            display="inline"
            href="https://docs.vvs.finance/product-guides/vvs-gotchi"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('here')}
          </Link>
          .
        </Text>
      </>
    ),
  },
  {
    banner: '/images/vvsGotchi/onboard-banners/step-2-team-up.png',
    content: (t) => (
      <>
        <Text fontSize="20px" fontWeight="600" mb="8px" color="black">
          {t('Step 1 - Assemble a Team')}
        </Text>
        <Text fontWeight="600" my="8px" color="black">
          {t('In order to begin playing, you will first need to create a team!')}
        </Text>
      </>
    ),
  },
  {
    banner: '/images/vvsGotchi/onboard-banners/step-3-quests.png',
    content: (t) => (
      <>
        <Text fontSize="20px" fontWeight="600" mb="8px" color="black">
          {t('Step 2 - Embark on Quests')}
        </Text>
        <Text fontWeight="600" my="8px" color="black">
          {t('Lead your Miner Moles on quests in order to earn Experience Points (EXP)!')}
        </Text>
      </>
    ),
  },
  {
    banner: '/images/vvsGotchi/onboard-banners/step-4-care.png',
    content: (t) => (
      <>
        <Text fontSize="20px" fontWeight="600" mb="8px" color="black">
          {t("Step 3 - Care for your Moles' health")}
        </Text>
        <Text fontWeight="600" my="8px" color="black">
          {t('Your Miner Moles need lots of love and attention to be productive while on quests!')}
        </Text>
      </>
    ),
  },
  {
    banner: '/images/vvsGotchi/onboard-banners/step-5-earn.png',
    content: (t) => (
      <>
        <Text fontSize="20px" fontWeight="600" mb="8px" color="black">
          {t('Step 4 - Earn more yield on your VVS Crystal farms!')}
        </Text>
        <Text fontWeight="600" my="8px" color="black">
          {t(
            'Rank as high as you can on the leaderboard so as to maximise your farm boost! Click below to get started, or check out our tutorials ',
          )}
          <Link
            display="inline"
            href="https://docs.vvs.finance/product-guides/vvs-gotchi"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('here')}
          </Link>
          .
        </Text>
      </>
    ),
  },
  {
    banner: '/images/vvsGotchi/onboard-banners/step-1-welcome.png',
    content: (t) => (
      <>
        <Text fontSize="20px" fontWeight="600" mb="8px" color="black">
          {t('Are you ready to play?')}
        </Text>
        <Text fontWeight="600" my="8px" color="black">
          {t(
            'Note: Background music will automatically start playing when you press the button below. You can choose to turn it off in the drop-down menu.',
          )}
        </Text>
      </>
    ),
  },
]

export default onboardSteps
